import type { FC } from "react";

import type { ActionAction, HeaderSdk, Pages } from "~/core";
import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import type { ButtonProps } from "~/shared/ui-kit";
import { Button } from "~/shared/ui-kit";

export type HeaderButtonProps = {
  item: NonNullable<
    ExtractArrayItemType<
      NonNullable<
        NonNullable<NonNullable<HeaderSdk>["additional_menu"]>["action_items"]
      >
    >
  >["menu_action_items_id"];
  getUrl: (page: Pages) => string;
  onCallAction: (action: ActionAction) => void;
} & ButtonProps<"button">;

export const HeaderButton: FC<HeaderButtonProps> = ({
  item,
  getUrl,
  onCallAction,
  ...props
}) => {
  const action = item?.action?.action?.[0];
  let href: string | undefined;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }

  const mobileButtonDisplay = item?.action?.inactive_if?.includes("isMobile")
    ? "hidden md:block"
    : "";

  const desktopButtonDisplay = item?.action?.inactive_if?.includes("isDesktop")
    ? "block md:hidden"
    : "";

  return (
    <Button
      {...props}
      href={href}
      className={`${mobileButtonDisplay} ${desktopButtonDisplay} ${props.className}`}
      variant={
        (props.variant ?? item?.variant === "underline")
          ? "transparent"
          : "default"
      }
      onPress={() => {
        if (action) {
          onCallAction(action);
        }
      }}
    >
      {item?.translations?.[0]?.name}
    </Button>
  );
};
